import React from "react";

interface InstagramIconSvgProps {
  smallWidth: boolean;
}

const InstagramIconSvg: React.FC<InstagramIconSvgProps> = ({ smallWidth }) => {
  return (
    <svg
      className={
        "h-[25px] w-[25px] md:h-[30px] md:w-[30px] lg:h-[35px] lg:w-[35px] xl:h-[43px] xl:w-[43px]"
      }
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      fill="none"
      viewBox="0 0 43 43"
    >
      <path
        fill="#16303A"
        d="M21.166 42.333c11.69 0 21.167-9.477 21.167-21.166C42.333 9.476 32.856 0 21.167 0 9.476 0 0 9.477 0 21.166c0 11.69 9.477 21.167 21.166 21.167z"
      ></path>
      <g fill="#fff" clipPath="url(#clip0_6_1727)">
        <path d="M24.019 18.98a3.562 3.562 0 11-5.038 5.039 3.562 3.562 0 015.038-5.038"></path>
        <path d="M25.656 12h-8.312A5.35 5.35 0 0012 17.344v8.312A5.35 5.35 0 0017.344 31h8.312A5.35 5.35 0 0031 25.656v-8.312A5.35 5.35 0 0025.656 12zM21.5 26.25c-2.62 0-4.75-2.13-4.75-4.75s2.13-4.75 4.75-4.75 4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75zm5.344-9.5a.594.594 0 110-1.188.594.594 0 010 1.188z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6_1727">
          <path
            fill="#fff"
            d="M0 0H19V19H0z"
            transform="translate(12 12)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default InstagramIconSvg;
